export enum TargetChoicesEnum {
    SCHOOL = 'school',
    IMPERSONATE = 'impersonate',
    ROUTING = 'routing',
    LOGOUT = 'logout',
    LOGOUT_PREVENT_BACK = 'logout_prevent_back',
    MODIFIED_FORM = 'modified_form',
}
